<template>
  <div id="user-edit-tab-info">

    <!-- Content Row -->
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full">
        <vs-input class="w-full mt-4" label="Event Name" v-model="form.name" v-validate="'required'" name="name" />
        <span class="text-danger text-sm"  v-show="errors.has('name')">{{ errors.first('name') }}</span>

        <vs-input class="w-full mt-4" label="Guest Count" v-model="form.guest_count" v-validate="'required|numeric'" name="company" />
        <span class="text-danger text-sm"  v-show="errors.has('guest_count')">{{ errors.first('guest_count') }}</span>

        <!--<vuetify-google-autocomplete

          v-model="form.location"
          :error-messages="errors.place_id"
          label="Event Location (ZIP code or city)"
          ref="location"
          :solo="!eventEditMode"
          outlined
          flat
          append-icon="mdi-map-marker"
          id="map"
          placeholder=""
          v-on:blur="checkAddressData"
          v-on:placechanged="getAddressData"
          v-on:no-results-found="noAddressData"
          country="us"
          types="(regions)"
        >
        </vuetify-google-autocomplete>
        <span class="text-danger text-sm"  v-show="errors.has('email')">{{ errors.first('email') }}</span>-->
      </div>

      <div class="vx-col md:w-1/2 w-full mt-6">

        <datepicker class="w-full mt-4" placeholder="Select Date" name="date" v-model="form.starts_at" v-validate="'required'"></datepicker>
        <span class="text-danger text-sm"  v-show="errors.has('date')">{{ errors.first('date') }}</span>


      </div>
    </div>
    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="save_changes" :disabled="!validateForm">Save Changes</vs-button>
          <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Reset</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import vSelect from 'vue-select'
import Form from 'vform'
/*import VuetifyGoogleAutocomplete from 'vuetify-google-autocomplete';
import Vue from 'vue'
Vue.use(VuetifyGoogleAutocomplete, {
  apiKey: 'AIzaSyDrliLIJlzfk2S2TP-tveVdkpltmq5YmLQ',
});*/


export default {
  components: {
    vSelect,
    Datepicker
    /*VuetifyGoogleAutocomplete*/
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {

      formData: JSON.parse(JSON.stringify(this.data)),
      addressSelected: false,
      form: new Form({
        name: '',
        starts_at: '',
        zip: '',
        city: '',
        state: '',
        location: '',
        location_point: {},
        place_id: '',
        guest_count: ''
      })

    }
  },
  computed: {
    /*status_local: {
      get () {
        return {
          label: this.capitalize(this.form.status),
          value: this.form.status
        }
      },
      set (obj) {
        this.form.status = obj.value
      }
    },
    role_local: {
      get () {
        return {
          label: this.capitalize(this.form.role),
          value: this.form.role
        }
      },
      set (obj) {
        this.form.role = obj.value
      }
    },*/
    validateForm () {
      return !this.errors.any()
    }
  },
  mounted () {
    this.form.name = this.formData.name
    this.form.guest_count = this.formData.guest_count
    this.form.location = this.formData.location
    this.form.zip = this.formData.zip
    this.form.state = this.formData.state
    this.form.city = this.formData.city
    this.form.location_point = this.formData.location_point
    this.form.place_id = this.formData.place_id
    this.form.starts_at = this.formData.starts_at

    this.form.id = this.formData.id
    this.form.name = this.formData.name
  },
  methods: {
    capitalize (str) {
      return str.slice(0, 1).toUpperCase() + str.slice(1, str.length)
    },
    save_changes () {
      /* eslint-disable */
      if (!this.validateForm) return

      // Here will go your API call for updating data
      // You can get data in "this.form"
      this.$store
        .dispatch("admin/updateEvent", this.form)
        .then((res) => {
          this.data_local = res.data.data
          this.$vs.notify({
            color: "success",
            title: "Event Updated",
            text: "The event was successfully updated"
          })
        })
        .catch((err) => {
          if (err.response.status === 404) {
            this.user_not_found = true
            return
          }
          console.error(err)
        })
      /* eslint-enable */
    },
    reset_data () {
      this.form = JSON.parse(JSON.stringify(this.data))
    },
    update_avatar () {
      // You can update avatar Here
      // For reference you can check dataList example
      // We haven't integrated it here, because data isn't saved in DB
    },
    async getAddressData (addressData, placeResultData, id) {
      //console.log(addressData)
      //console.log(placeResultData)
      this.errors.place_id = []
      if (typeof addressData.locality === 'undefined') {
        //this.errors.place_id = ['Please enter a valid city or ZIP code']
        //this.$refs.location.update('');
        //return false;

        let zipcode = false
        if (typeof addressData.postal_code !== 'undefined') {
          zipcode = addressData.postal_code
        }

        if (zipcode) {
          const url = `/zip2location?zipcode=${zipcode}`
          const { data } = await axios.get(url)
          addressData.locality = data.data.city
        }
      }
      //console.log(addressData)
      //console.log(placeResultData)
      const location = []
      if (addressData.locality) {
        this.form.city = addressData.locality
        location.push(addressData.locality)
      } else {
        this.form.city = ''
      }
      if (addressData.administrative_area_level_1) {
        this.form.state = addressData.administrative_area_level_1
        location.push(addressData.administrative_area_level_1)
      } else {
        this.form.state = ''
      }
      if (addressData.postal_code) {
        this.form.zip = addressData.postal_code
      } else {
        this.form.zip = ''
      }
      this.showCityState = true

      this.$refs.location.update(location.join(', '))

      //
      this.form.location_point = {
        latitude: addressData.latitude,
        longitude: addressData.longitude
      }
      this.form.place_id = addressData.place_id
      this.addressSelected = placeResultData.formatted_address
    },
    checkAddressData () {

      this.$nextTick(function () {
        //console.log(this.addressSelected)
        //console.log(this.form.location)
        if (this.addressSelected != this.form.location) {
          this.form.location_point = {}
          this.form.place_id = ''
          this.addressSelected = false
          //console.log('reset')
        }

      })
    },
    noAddressData () {

    }
  }
}
</script>
